import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const scrollFn = /* @__PURE__ */ createRecipe('scroll', {}, [])

const scrollVariantMap = {}

const scrollVariantKeys = Object.keys(scrollVariantMap)

export const scroll = /* @__PURE__ */ Object.assign(memo(scrollFn.recipeFn), {
  __recipe__: true,
  __name__: 'scroll',
  __getCompoundVariantCss__: scrollFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: scrollVariantKeys,
  variantMap: scrollVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, scrollVariantKeys)
  },
  getVariantProps: scrollFn.getVariantProps,
})